/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


var expocadfx = expocadfx || {};

expocadfx.fxData = {
    version: "4.7.0b",
    debug: false,
    queryEvent: "",
    queryBooths: "",
    queryIndex: "",
    queryCoord: "",
    queryAuthKey: "",
    queryExhibitor: "",
    queryUnits: "",
    queryMessage: "",
    queryActCode: "",
    mode: "",
    coords: false,
	device: "other",
    notOldios: true,
    firefox: false,
	msie: false,
    exhibitors: [],
    eventExhibitors: [],
    displayExhibitors : [],
	displayBooths: [],
    booths: [],
    boothGraphics: [],
    boothText: [],
    floorPlanText: [],
	pavilionLabels: [],
    buildingText: [],
    pavilions: [],
    eventBooths : [],
    favoriteBooths : [],
	favoriteMarks2d : [],		// created by drawing(2d), needed by pdf output
	selected2d : [],			// created by drawing(2d), needed by pdf output
    selectedBooths: [],
    arViews: [],
    arOverlays: [],
	arTechLayers: [],
	arLayersMenuItems: [],
	
	arCircles: [],
	arArcs: [],
	
	addedGraphics: null,
    hasSpns: false,
    xmlBooths: "",
    xmlBldgTxt: "",
    jsonBldgTxt: null,
    xmlTechLayers: "",
    jsonTechLayers: "",
    selectedRow: -1,
    grid: null,
    viewportWidth: 0,
    viewportHeight: 0,
	headerHeight: 0,
    initialAccordionHeight: 0,
    pageHeight: 0,
    numAvailableBooths: 0,
    numOnHoldBooths: 0,
    filterExhibitorList: true,
    searchString: "",
    updateNumber: 0,
    lastMessageNumber: -1, // Will need to be set from the config endpoint? Default to 0 - ANH
    smallLayout: false,
    bDrawBuilding: true,
    languagePreference: "",
    tempBooths: [],
    tempBoothsStyle: [],
	linkPreviewWindow: null,
    
    menuPending: false,
    iahPending: false,
	gaAccount: null, // Google Analytics Account number
	pdfOk: true,
    
    miniMap: null,
    userMovedMap: false,
    userMovedMapSales: false,
    salesWindow: null,
	
	premiumCompanies: [],
	premiumLevels: [],
    
    salesUrl: "",
    salesAllowedCommands: [],
    salesIniUser: "",
    salesIniPswd: "",
    salesPort: "",
    salesIdleLimit: "10",
    pendingZoomBoothNumber: "",
    hatchedBooths: false,
	
	startTime: 0,
    
    status: {
            textReady : false,
            exhibitorsReady : false,
            buildingTextReady : false,
            boothObjectsReady: false,
            floorPlanReady: false,
            favoritesReady: false,
			overlaysReady: false
        }
};
